import { StyleSheet } from 'aphrodite';

const stepsInteritemSpacer = 34;

export const styleSheet = StyleSheet.create({
	stepSeparator: {
		height: stepsInteritemSpacer,
	},
	lastStep: {
		marginBottom: 250,
	},
});
